import { EmeraldButton } from "@emerald-react/button";
import { EmeraldModal } from "@emerald-react/modal";

interface LocationAdjustmentModalProps {
  isOpen: boolean;
  pendingUpdate: {
    propId: string;
    latLng: { lng: number; lat: number };
    data: any;
    isLeaseComp?: boolean;
  } | null;
  onClose: () => void;
  onUpdateCoordinates: () => void;
  onUpdatePdfOnly: () => void;
}

const LocationAdjustmentModal = ({
  isOpen,
  onClose,
  onUpdateCoordinates,
  onUpdatePdfOnly,
}: LocationAdjustmentModalProps) => {
  return (
    <EmeraldModal
      opened={isOpen}
      onClose={onClose}
      hasCloseIcon
      headerText="Location Adjustment"
      className="location-adjustment-modal"
      zIndex={1000}
      actionTemplate={
        <>
          <EmeraldButton
            label="Yes, update both the Web & PDF Survey"
            type="Primary"
            onClick={onUpdateCoordinates}
            className="mdc-dialog__button"
            color="primary"
            tabIndex={0}
          />
          <EmeraldButton
            label="No, only update the PDF Survey"
            type="Secondary"
            onClick={onUpdatePdfOnly}
            className="mdc-dialog__button"
            color="primary"
            tabIndex={0}
          />
        </>
      }
    >
      <div className="flex flex-col outline-none" style={{ padding: "0 20px" }}>
        <p className="text-base">
          This change will update the location on the{" "}
          <strong>PDF Survey only</strong>. Would you like to update the Web
          Survey too?
        </p>
      </div>
    </EmeraldModal>
  );
};

export default LocationAdjustmentModal;
